/*eslint-disable*/
import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// core components
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import { useTranslation } from "react-i18next";
import { useMedia } from 'react-use';
import { ReactComponent as UserCircleIcon } from "assets/icons/user-circle.svg";
import { Box, SvgIcon, Tooltip } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getAuthInfo, getUserInfoSidebar } from "../../store/slices/auth";
import { getExtendSidebar, toggleSidebar } from "store/slices/layout";
import AppConfig, { SYSTEM_ROLE } from "../../config/AppConfig";
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { drawerWidth } from "assets/jss/material-dashboard-react";
import { useState } from "react";
import moment from "moment";
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Fragment } from "react";

const { APPROVAL_STATUS } = AppConfig;

const useStyles = makeStyles((theme) => ({
    ...styles(theme),
    bg: {
        backgroundColor: '#ffffff'
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    toggleSidebar: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    boxSidebar: {
        flex: "0 0 auto"
    },
    boxSidebarScroll: {
        flex: "1 0 auto",
        display: "flex"
    },
    collapse: {
        width: "80px!important",
        minWidth: "80px"
    },
    wrapper: {
        position: 'relative',
        width: drawerWidth
    },
    subMenuItem: {
        marginLeft: '10px'
    }
}));

const AdminSideBar = (props) => {
    const { t } = useTranslation();
    const location = useLocation();
    const classes = useStyles();
    const dispatch = useDispatch();

    const userInfo = useSelector(getAuthInfo);
    const extendSidebar = useSelector(getExtendSidebar);
    const userInfoSidebar = useSelector(getUserInfoSidebar);
    const [isExpired, setExpired] = useState(false);
    const [openDropdowns, setOpenDropdowns] = useState(new Map());

    const [authInfo, setAuthInfo] = useState({
        organizationName: '',
        firstName: '',
        lastName: ''
    });

    // verifies if routeName is the one active (in browser input)
    function activeRoute(routeName) {
        return window.location.href.indexOf(routeName) > -1 ? true : false;
    }
    const {
        color, logo, image, logoText, routes, open, isMobile, setMobileOpen,
        handleDrawerToggle
    } = props;

    const below959 = useMedia('(max-width: 959px)');
    const below600 = useMedia('(max-width: 600px)');

    const newRef = useRef(null);

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            // console.log('event', event.target);
            if ((newRef.current && !newRef.current.contains(event.target))) {
                // alert("You clicked outside of me!");
                // console.log('hack', open, isMobile);
                if (open && isMobile) {
                    setMobileOpen(false);
                }
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });

    useEffect(() => {
        if (userInfoSidebar) {
            setAuthInfo(userInfoSidebar);
        }
    }, [userInfoSidebar]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (userInfo && userInfo.role === SYSTEM_ROLE.COMPANY && userInfo.companySubcriptionExpiryDate) {
                const _expiredDate = moment(userInfo.companySubcriptionExpiryDate);
                const currentDate = moment();
                if (_expiredDate.diff(currentDate) > 0) {
                    setExpired(false);
                } else {
                    setExpired(true);
                    clearInterval(interval);
                }
            }
        }, 100);
    }, [userInfo]);

    useEffect(() => {
        for (const subMenu of routes.filter(menuFilterSubMenu)) {
            if (activeRoute(subMenu.path)) {
                const map = new Map();
                map.set(subMenu.parentName, true);
                setOpenDropdowns(map);
                break;
            }
        }
    }, [location]);

    /**
     * Filter out inaccessible menu
     * @param e
     * @returns {boolean}
     */
    const hasRoutePermission = (e) => {
        if (!e.permission) {
            return true;
        }
        return Array.isArray(userInfo.permissions) && userInfo.permissions.includes(e.permission);
    }

    const menuFilter = (e) => {
        // if (e.isSubMenu) {
        //     return false;
        // }
        if (userInfo.role === SYSTEM_ROLE.SUPER_ADMIN) {
            if (e.permission) {
                return !e.path.includes('participants') && !e.path.includes('workers') && !e.path.includes('booking') && !e.path.includes('billing') && !e.path.includes('options')
                    && !e.path.includes('payroll') && !e.path.includes('jobs') && !e.path.includes('subscriptions') && !e.path.includes('rates') && !e.path.includes('financial') && !e.path.includes('search-worker') && e.isMenu;
            } else {
                // return e.isMenu && e.layout === '/admin' && !e.path.includes('account');
                return e.isMenu && e.layout === '/admin' && e.path !== '/setting/account' && e.path !== '/setting-accounting' && !e.path.includes('/options') && !e.path.includes('financial') && !e.path.includes('search-worker');
            }
        } else if (userInfo.role === SYSTEM_ROLE.MANAGER) {
            if (e.permission) {
                return e.isMenu && e.layout === '/admin' && hasRoutePermission(e);
            } else {
                // return e.isMenu && e.layout === '/admin' && !e.path.includes('account');
                return e.isMenu && e.layout === '/admin' && e.path !== '/setting/account' && e.path !== '/setting-accounting' && !e.path.includes('/options') && !e.path.includes('financial') && !e.path.includes('search-worker');
            }
        } else if (userInfo.role === SYSTEM_ROLE.COMPANY) {
            if (userInfo.owner) {
                if (userInfo.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
                    return;
                } else {
                    if (e.permission) {
                        return e.isMenu && e.layout === '/admin' && hasRoutePermission(e);
                    } else {
                        return e.isMenu && e.layout === '/admin';
                    }
                }
            } else {
                if (e.permission) {
                    return e.isMenu && e.layout === '/admin' && e.path !== '/users' && hasRoutePermission(e);
                } else {
                    return e.isMenu && e.layout === '/admin' && e.path !== '/setting/account' && e.path !== '/setting-accounting';
                }
            }
        }
    }
    const menuFilterSubMenu = (e) => {
        if (!e.isSubMenu) {
            return false;
        }
        if (userInfo.role === SYSTEM_ROLE.SUPER_ADMIN) {
            if (e.permission) {
                return !e.path.includes('participants') && !e.path.includes('workers') && !e.path.includes('booking') && !e.path.includes('billing') && !e.path.includes('options')
                    && !e.path.includes('payroll') && !e.path.includes('jobs') && !e.path.includes('subscriptions') && !e.path.includes('rates') && e.isMenu;
            } else {
                // return e.isMenu && e.layout === '/admin' && !e.path.includes('account');
                return e.isSubMenu && e.layout === '/admin' && e.path !== '/setting/account' && e.path !== '/setting-accounting';
            }
        } else if (userInfo.role === SYSTEM_ROLE.MANAGER) {
            if (e.permission) {
                return e.isSubMenu && e.layout === '/admin' && hasRoutePermission(e) && !e.path.includes('/options');
            } else {
                // return e.isMenu && e.layout === '/admin' && !e.path.includes('account');
                return e.isSubMenu && e.layout === '/admin' && e.path !== '/setting/account' && e.path !== '/setting-accounting';
            }
        } else if (userInfo.role === SYSTEM_ROLE.COMPANY) {
            if (userInfo.owner) {
                if (userInfo.approvalStatus !== APPROVAL_STATUS.ACTIVE) {
                    return;
                } else {
                    if (e.permission) {
                        return e.isSubMenu && e.layout === '/admin' && hasRoutePermission(e);
                    } else {
                        return e.isSubMenu && e.layout === '/admin';
                    }
                }
            } else {
                if (e.permission) {
                    return e.isSubMenu && e.layout === '/admin' && hasRoutePermission(e);
                } else {
                    // return e.isMenu && e.layout === '/admin' && !e.path.includes('account');
                    return e.isSubMenu && e.layout === '/admin' && e.path !== '/setting/account' && e.path !== '/setting-accounting';
                }
            }
        }
    }

    const handleDropdowns = (key) => {
        const newOpenDropdowns = new Map(openDropdowns);
        if (newOpenDropdowns.get(key)) {
            newOpenDropdowns.set(key, false);
        } else {
            newOpenDropdowns.set(key, true);
        }
        setOpenDropdowns(newOpenDropdowns)
    }

    const renderSubMenu = (name, menuDropdowns) => {
        if (!menuDropdowns.get(name)) {
            return;
        }
        const subList = menuDropdowns.get(name);
        const ParentIcon = subList[0].icon;
        return (
            <Fragment key={name}>
                <ListItem
                    button
                    className={classes.itemLink}
                    onClick={() => {
                        handleDropdowns(name)
                    }}
                >
                    <Tooltip title={t(name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                        <ParentIcon className={classNames(classes.itemIcon)} />
                    </Tooltip>
                    {((extendSidebar && !below959) || (isMobile && open)) && <ListItemText
                        primary={t(name)}
                        className={classNames(isMobile ? classes.itemTextMobile : classes.itemText)}
                        disableTypography={true}
                    />}
                    {openDropdowns.get(name) ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openDropdowns.get(name)} timeout="auto" unmountOnExit >
                    <List component="div" disablePadding>
                        {subList.map((prop, index) => {
                            let activePro = " ";
                            let listItemClasses;
                            listItemClasses = classNames({
                                [" " + classes[color]]: activeRoute(prop.path)
                            });
                            const violetFontClasses = classNames({
                                [" " + classes.violetFont]: activeRoute(prop.path)
                            });
                            return (
                                <NavLink
                                    to={(prop.layout + prop.path)}
                                    className={activePro + classes.item}
                                    activeClassName="active"
                                    key={index}
                                    onClick={() => isMobile && setMobileOpen(false)}
                                >
                                    <ListItem button className={`${classes.itemLink + listItemClasses}`} style={{ marginRight: 0 }}>
                                        <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                                            <prop.subIcon className={`${classes.subMenuItem} ${classNames(classes.itemIcon)}`} />
                                        </Tooltip>
                                        {((extendSidebar && !below959) || (isMobile && open)) && <ListItemText
                                            primary={t(prop.subname)}
                                            className={classNames(isMobile ? classes.itemTextMobile : classes.itemText, violetFontClasses)}
                                            disableTypography={true}
                                        />}
                                    </ListItem>
                                </NavLink>
                            );
                        })}
                    </List>
                </Collapse>
            </Fragment>
        )
    }

    const links = () => {
        const menuDropdowns = new Map();
        const parentMenuUsed = new Map();
        routes.filter(menuFilterSubMenu).forEach((prop) => {
            if (!menuDropdowns.get(prop.parentName)) {
                menuDropdowns.set(prop.parentName, []);
            }
            menuDropdowns.get(prop.parentName).push(prop);
        })
        return (
            <List className={classes.list}  >
                {routes.filter(menuFilter).map((prop, key) => {
                    if (prop.isSubMenu && prop.parentName) {
                        if (parentMenuUsed.get(prop.parentName)) {
                            return;
                        }
                        parentMenuUsed.set(prop.parentName, true);
                        return renderSubMenu(prop.parentName, menuDropdowns);
                    }
                    let activePro = " ";
                    let listItemClasses;
                    listItemClasses = classNames({
                        [" " + classes[color]]: activeRoute(prop.path)
                    });
                    const violetFontClasses = classNames({
                        [" " + classes.violetFont]: activeRoute(prop.path)
                    });
                    return (
                        <NavLink
                            to={(prop.layout + prop.path)}
                            className={activePro + classes.item}
                            activeClassName="active"
                            key={key}
                            onClick={() => isMobile && setMobileOpen(false)}
                        >
                            <ListItem button className={classes.itemLink + listItemClasses}>
                                {typeof prop.icon === "object" && prop.icon.type === 'font-awesome' ? (
                                    <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                                        <i style={{ fontSize: 'unset' }} className={classNames(classes.itemIcon, prop.icon.icon)} />
                                    </Tooltip>
                                ) : typeof prop.icon === "string" ? (
                                    <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                                        <img
                                            src={prop.icon}
                                            className={classNames(classes.itemIcon)}
                                        />
                                    </Tooltip>
                                ) : (
                                    <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                                        <prop.icon
                                            className={classNames(classes.itemIcon)}
                                        />
                                    </Tooltip>
                                )}

                                {((extendSidebar && !below959) || (isMobile && open)) && <ListItemText
                                    primary={t(prop.name)}
                                    className={classNames(isMobile ? classes.itemTextMobile : classes.itemText, violetFontClasses)}
                                    disableTypography={true}
                                />}

                            </ListItem>
                        </NavLink>
                    );
                })}
            </List>
        )
    }

    const user = (
        <List className={classNames([classes.list])}>
            <div className={classes.item}>
                <div className={`${classes.itemLink} ${isMobile ? classes.wrapUserInfoMobile : classes.wrapUserInfo}`}>
                    <SvgIcon component={UserCircleIcon} viewBox="0 0 512 512" className={classes.itemIcon} />
                    {((extendSidebar && !below959) || (isMobile && open)) && <div className={classNames(isMobile ? classes.userInfoMobile : classes.userInfo)}>
                        <span className="font-weight-bold">
                            {authInfo.firstName || userInfo.firstName} {authInfo.lastName || userInfo.lastName}
                        </span>
                        <span>
                            {userInfo.role === SYSTEM_ROLE.COMPANY ? userInfo.owner ? t(`user_role.${userInfo.role}_ADMIN`) : t(`user_role.${userInfo.role}_USER`) : t(`user_role.${userInfo.role}`)}
                        </span>
                    </div>}
                </div>
            </div>
            {
                routes.filter(e => e.isMenuTop).map((prop, key) => (
                    <NavLink
                        to={(prop.layout + prop.path)}
                        className={classes.item}
                        activeClassName="active"
                        key={`sb-user-${key}`}
                        onClick={() => isMobile && setMobileOpen(false)}
                    >
                        <ListItem button className={classes.itemLink}>
                            <Tooltip title={t(prop.name)} placement="right" disableHoverListener={!below959 && extendSidebar}>
                                <SvgIcon component={prop.icon} viewBox="0 0 512 512" className={classNames(classes.itemSmallIcon)} />
                            </Tooltip>
                            {((extendSidebar && !below959) || (isMobile && open)) && <ListItemText
                                primary={t(prop.name)}
                                className={classNames(isMobile ? classes.itemTextMobile : classes.itemText)}
                                disableTypography={true}
                            />}
                        </ListItem>
                    </NavLink>
                ))
            }
        </List>
    );
    const bottom = (
        <List className={classes.list}>
            {routes.filter(e => e.isMenuBottom).map((prop, key) => {
                let activePro = " ";
                let listItemClasses;
                listItemClasses = classNames({
                    [" " + classes[color]]: activeRoute(prop.path)
                });
                const violetFontClasses = classNames({
                    [" " + classes.violetFont]: activeRoute(prop.path)
                });
                return (
                    <NavLink
                        to={prop.path}
                        className={activePro + classes.item}
                        activeClassName="active"
                        key={key}
                    >
                        <ListItem button className={classes.itemLinkBottom + listItemClasses}>
                            {((extendSidebar && !below959) || (isMobile && open)) && <ListItemText
                                primary={t(prop.name)}
                                className={classNames(violetFontClasses)}
                                disableTypography={true}
                            />}
                            <i className={`fas fa-chevron-right ${classes.itemIconBottom}`}></i>
                        </ListItem>
                    </NavLink>
                );
            })}
        </List>
    );
    return (
        <Box className={classNames({
            [classes.boxSidebar]: true,
            [classes.wrapper]: !below959,
            [classes.collapse]: !below600 && (!extendSidebar || below959)
        })}>
            <Drawer
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classNames({
                        [classes.drawerPaper]: !isMobile,
                        [classes.drawerPaperMobile]: isMobile,
                        [classes.bg]: true,
                        [classes.collapse]: !extendSidebar
                    }),
                }}
                onClose={props.handleDrawerToggle}
                ModalProps={{
                    keepMounted: true // Better open performance on mobile.
                }}
            >
                {user}
                <PerfectScrollbar
                    className={classNames({
                        [classes.sidebarWrapper]: !isMobile,
                        [classes.sidebarWrapperMobile]: isMobile,
                        [classes.collapse]: !extendSidebar
                    })}
                    options={{
                        suppressScrollX: true,
                        suppressScrollY: false
                    }}
                >
                    {links()}
                    {routes.find(e => e.isMenuBottom) && bottom}
                </PerfectScrollbar>
                {
                    !below959 && (
                        <Box
                            padding="1rem 0.25rem"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            className={classes.toggleSidebar}
                            onClick={() => dispatch(toggleSidebar(!extendSidebar))}
                        >
                            <DoubleArrowIcon
                                className={classNames({
                                    [classes.rotate]: extendSidebar
                                })}
                            />
                            {
                                extendSidebar && (
                                    <span
                                        style={{
                                            fontSize: 14
                                        }}
                                        className="ml-3"
                                    >{t("label.collapseSidebar")}</span>
                                )
                            }
                        </Box>
                    )
                }
            </Drawer>
        </Box>
    );
}

AdminSideBar.propTypes = {
    rtlActive: PropTypes.bool,
    handleDrawerToggle: PropTypes.func,
    bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
    logo: PropTypes.string,
    image: PropTypes.string,
    logoText: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    open: PropTypes.bool,
    isMobile: PropTypes.bool,
    setMobileOpen: PropTypes.func
};

export default AdminSideBar;
